import { combineReducers } from 'redux';
import {
  FETCH_HEALTH_STATUS_REQUEST,
  FETCH_HEALTH_STATUS_SUCCESS,
  FETCH_HEALTH_STATUS_FAILURE,
} from '../../constants/ActionTypes';

const info = (
  state = { data: {}, isFetching: false, errorMessage: null },
  action
) => {
  switch (action.type) {
    case FETCH_HEALTH_STATUS_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_HEALTH_STATUS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data.data,
      };
    case FETCH_HEALTH_STATUS_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    default:
      return state;
  }
};

const healthStatus = combineReducers({
  info,
});

export default healthStatus;
